import { VideoAssetsAPI } from './VideoAssetsAPI';
import { apiConfig } from '../../../utils/apiConfig';
import { IDataApiController, ApiResponsePromise } from '../../API/useApi';
import { VideoAssetBody, VideoAssetResponse } from '../../../API';

export function useVideoAssetsAPI(): Partial<IDataApiController<VideoAssetResponse, VideoAssetBody>> {
  const api = new VideoAssetsAPI(apiConfig);

  return {
    ...api,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    create: (record: VideoAssetResponse | VideoAssetBody, file: File): ApiResponsePromise<VideoAssetResponse> => {
      return api.create(record as VideoAssetBody, file);
    }
  };
}
